import EDFError from './edf.error';

export default class ClientError extends EDFError {
    constructor(message: string, code?: string, cause?: Error) {
        super(message, code || 'EDF:ClientError', cause);
    }
}
